import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingService } from '../../services/loading.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModusWcLoader } from '@trimble-oss/moduswebcomponents-angular';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [CommonModule, ModusWcLoader],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.scss',
})
export class GlobalLoaderComponent {
  private loadingService = inject(LoadingService);
  isLoading = toSignal(this.loadingService.isLoading$, { initialValue: false });
}
